var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DeleteConfirm',_vm._b({attrs:{"itemKey":"TicketRevenue","fetchData":_vm.fetchData,"setTitle":_vm.setTitle,"setQuestion":_vm.setQuestion,"deleteData":_vm.deleteData},on:{"onDelete":(response) => _vm.$emit('onDelete', response)}},'DeleteConfirm',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }